import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Profile } from './Profile';

interface UserProps {
    match: { url: string };
}

// Type assertions for TypeScript 5.x compatibility with react-router-dom v5
const SwitchComponent = Switch as any;
const RouteComponent = Route as any;

export function User({ match }: UserProps) {
    return (
        <SwitchComponent>
            <RouteComponent path={`${match.url}/`} component={Profile} exact />
        </SwitchComponent>
    );
}
